import type React from 'react'

const FileXml: React.FC = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.7929 25.999H50C48.3431 25.999 47 24.6559 47 22.999V13.2061C47 12.7607 47.5386 12.5376 47.8536 12.8526L60.1464 25.1455C60.4614 25.4605 60.2383 25.999 59.7929 25.999Z"
        fill="#18C4A9"
      />
      <path
        d="M20.5 58.399V21.599C20.5 19.8941 20.5012 18.7056 20.5768 17.7804C20.6509 16.8726 20.7892 16.3511 20.9905 15.9561C21.4219 15.1093 22.1103 14.4209 22.957 13.9895C23.3521 13.7882 23.8736 13.65 24.7814 13.5758C25.7066 13.5002 26.8951 13.499 28.6 13.499H46.0236C47.5625 13.499 48.0875 13.5087 48.5652 13.6234C49.0244 13.7336 49.4633 13.9154 49.866 14.1621C50.2849 14.4189 50.6629 14.7833 51.7511 15.8715L57.1276 21.2479C58.2158 22.3361 58.5802 22.7141 58.8369 23.1331C59.0836 23.5357 59.2654 23.9746 59.3757 24.4338C59.4904 24.9115 59.5 25.4365 59.5 26.9755V58.399C59.5 60.1039 59.4988 61.2924 59.4232 62.2177C59.3491 63.1254 59.2108 63.6469 59.0095 64.042C58.5781 64.8887 57.8897 65.5771 57.043 66.0086C56.6479 66.2098 56.1264 66.3481 55.2186 66.4223C54.2934 66.4979 53.1049 66.499 51.4 66.499H28.6C26.8951 66.499 25.7066 66.4979 24.7814 66.4223C23.8736 66.3481 23.3521 66.2098 22.957 66.0086C22.1103 65.5771 21.4219 64.8887 20.9905 64.042C20.7892 63.6469 20.6509 63.1254 20.5768 62.2177C20.5012 61.2924 20.5 60.1039 20.5 58.399Z"
        stroke="#18C4A9"
        strokeWidth="3"
      />
      <rect x="15" y="35.999" width="50" height="32" fill="white" />
      <path
        d="M24 43.999C19.9529 48.0461 19.3561 48.6429 15.7084 52.2906C15.3179 52.6812 15.3166 53.3156 15.7071 53.7061L24 61.999"
        stroke="#18C4A9"
        strokeWidth="6"
        strokeLinecap="square"
      />
      <path
        d="M56 43.999C60.0471 48.0461 60.6439 48.6429 64.2916 52.2906C64.6821 52.6812 64.6834 53.3156 64.2929 53.7061L56 61.999"
        stroke="#18C4A9"
        strokeWidth="6"
        strokeLinecap="square"
      />
      <path
        d="M45 39.999L35 65.999"
        stroke="#18C4A9"
        strokeWidth="6"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default FileXml
